const en = {
  "layout": {
    "overview":"Overview",
    "dashboard": "Dashboard",
    "profile":"Profile",
    "project":"Project",
    "security":"Security",
    "accountSetting":"Account Setting",
    "home": {
      "home": "Home",
      "banner": "Banner",
      "solution":"Solution",
      "contact":"Contact",
    },
    "banner": {
      "subSection1": "Phần con 1",
      "subSection2": "Phần con 2"
    },
    "success": "Thành công",
    "updateSuccess": "Dữ liệu được cập nhật thành công!"
  },
  "home": {

  },
  "sizeIdeal": "Ideal size",
  "edit": "Edit",
  "update":"Update",
  "continue": "Continue",
  "agree":"Agree",
  "cancel": "Cancel",
  "titleFile": "Click or drag file to this area to upload",
  "descFile": "Support for a single upload. Strictly prohibited from uploading company data or other banned files.",
  "exitModal":"Exit without saving?",
  "descExitModal":"Do you want to exit without saving data?",
  "basicInformation": "Basic Information",
  "tag": "Tag",
  "title": "Title",
  "describtion": "Describtion",
  "imageInfo": "Image Information",
  "messUpdate":"Data updated successfully!",
  "tagInfo": {
    "message": "Please enter tags!",
    "placeholder": "Tags Content"
  },
  "titleInfo": {
    "message": "Please enter a title!",
    "placeholder": "Title Content"
  },
  "descInfo": {
    "message": "Please enter a description!",
    "placeholder": "Description Content"
  },

};

export default en;
